import { Link } from "react-router-dom";
import { X, Plus, Minus, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { gbp } from "@/lib/api";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, removeItem, subtotal, count } = useCart();

  return (
    <>
      <div
        className={`fixed inset-0 bg-secondary/40 z-[60] transition-opacity ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={() => setOpen(false)}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full max-w-md bg-background z-[70] shadow-2xl flex flex-col transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex items-center justify-between px-5 h-16 border-b border-border">
          <h3 className="font-display font-bold text-lg flex items-center gap-2">
            <ShoppingCart className="w-5 h-5 text-primary" /> Your Basket ({count})
          </h3>
          <button onClick={() => setOpen(false)} data-testid="cart-close" className="p-2 hover:bg-muted rounded-sm"><X className="w-5 h-5" /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 grid place-items-center text-center px-8">
            <div>
              <ShoppingCart className="w-12 h-12 mx-auto text-muted-foreground/40" />
              <p className="mt-4 text-muted-foreground">Your basket is empty.</p>
              <button onClick={() => setOpen(false)} className="mt-4 text-sm font-semibold text-primary hover:underline">Continue shopping</button>
            </div>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
              {items.map((it) => (
                <div key={it.product_id} className="flex gap-3" data-testid={`cart-item-${it.slug}`}>
                  <img src={it.image} alt={it.name} className="w-20 h-20 object-cover rounded-sm border border-border bg-white" />
                  <div className="flex-1 min-w-0">
                    <Link to={`/products/${it.slug}`} onClick={() => setOpen(false)} className="text-sm font-medium line-clamp-2 hover:text-primary">{it.name}</Link>
                    <p className="text-sm font-bold mt-1">{gbp(it.price)}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <div className="flex items-center border border-border rounded-sm">
                        <button onClick={() => updateQty(it.product_id, it.qty - 1)} className="p-1.5 hover:bg-muted" data-testid={`cart-dec-${it.slug}`}><Minus className="w-3.5 h-3.5" /></button>
                        <span className="w-8 text-center text-sm">{it.qty}</span>
                        <button onClick={() => updateQty(it.product_id, it.qty + 1)} className="p-1.5 hover:bg-muted" data-testid={`cart-inc-${it.slug}`}><Plus className="w-3.5 h-3.5" /></button>
                      </div>
                      <button onClick={() => removeItem(it.product_id)} className="text-xs text-destructive hover:underline" data-testid={`cart-remove-${it.slug}`}>Remove</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-border p-5 space-y-3">
              <div className="flex justify-between text-sm"><span className="text-muted-foreground">Subtotal</span><span className="font-bold" data-testid="cart-subtotal">{gbp(subtotal)}</span></div>
              <Link to="/cart" onClick={() => setOpen(false)} data-testid="view-basket-btn" className="block text-center border border-border rounded-sm py-2.5 text-sm font-semibold hover:bg-muted transition-colors">View Basket</Link>
              <Link to="/checkout" onClick={() => setOpen(false)} data-testid="checkout-btn" className="block text-center bg-accent text-white rounded-sm py-3 text-sm font-bold hover:bg-accent/90 transition-colors">Secure Checkout</Link>
            </div>
          </>
        )}
      </aside>
    </>
  );
}
